import { useEffect, useState } from 'react';
import { t } from '../../theme';

/**
 * The glance-from-the-doorway tile.
 *
 * Ticks on the minute rather than the second: a wall panel showing seconds
 * invites you to watch it, and re-rendering 60× more often earns nothing.
 */
export function ClockWidget() {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const align = (60 - now.getSeconds()) * 1000;
    let interval: ReturnType<typeof setInterval>;
    const timeout = setTimeout(() => {
      setNow(new Date());
      interval = setInterval(() => setNow(new Date()), 60_000);
    }, align);
    return () => {
      clearTimeout(timeout);
      clearInterval(interval);
    };
    // Re-aligning on every tick would rebuild the timer each minute; the first
    // alignment is enough to sit on the minute boundary from then on.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      style={{
        borderRadius: 28,
        background: t.surfaceRaised,
        boxShadow: 'inset 0 1px 0 oklch(1 0 0 / 0.07), 0 18px 34px -26px oklch(0.05 0 0 / 0.9)',
        padding: '18px 22px',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        minWidth: 0,
      }}
    >
      <div style={{ fontSize: 60, fontWeight: 500, letterSpacing: '-0.05em', lineHeight: 1 }}>
        {now.toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit' })}
      </div>
      <div style={{ marginTop: 6, fontSize: 17, color: t.inkMuted, textWrap: 'pretty' }}>
        {now.toLocaleDateString('de-DE', { weekday: 'long', day: 'numeric', month: 'long' })}
      </div>
    </div>
  );
}
